/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Lpvisibilitywarning_Description3Inputs */

const en_coinvestments_lpvisibilitywarning_description3 = /** @type {(inputs: Coinvestments_Lpvisibilitywarning_Description3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edits to this value will also be visible to Organisation users`)
};

/**
* | output |
* | --- |
* | "Edits to this value will also be visible to Organisation users" |
*
* @param {Coinvestments_Lpvisibilitywarning_Description3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lpvisibilitywarning_description3 = /** @type {((inputs?: Coinvestments_Lpvisibilitywarning_Description3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lpvisibilitywarning_Description3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lpvisibilitywarning_description3(inputs)
});
export { coinvestments_lpvisibilitywarning_description3 as "coInvestments_lpVisibilityWarning_description" }